import mapQrModal from './mapQrModal';

function extractPassThroughProps(componentsData) {
  const { id, imageUploader, buttonProps, additionalButtonProps, ...passThroughProps } =
    componentsData;

  return passThroughProps;
}

function extractButtonProps(btnProps) {
  if (!btnProps) return undefined;

  return mapQrModal(btnProps);
}

function extractImageUploader(imageUploader) {
  if (!imageUploader) return {};

  const { suggestedImagesList = [], ...imageUploaderData } = imageUploader;

  return {
    imageUploader: {
      ...imageUploaderData,
      suggestedImagesList: suggestedImagesList.map(img => img.url),
    },
  };
}

export default function bannerWithImageMapper(componentsData) {
  return {
    ...extractPassThroughProps(componentsData),
    ...extractImageUploader(componentsData.imageUploader),
    buttonProps: extractButtonProps(componentsData.buttonProps),
    additionalButtonProps: extractButtonProps(componentsData.additionalButtonProps),
  };
}
